import {
  ConfigurationHelper,
  IApplicationMenuItemComponentModel,
} from "@nf/common";
import { useTranslation } from "next-i18next";
import cx from "classnames";

import { LinkWithLocale } from "components";

import ChevronDown from "resources/icons/chevron-down.svg";

import styles from "./ApplicationMenuDropdown.module.scss";

interface ApplicationMenuDropdownProps {
  className?: string;
  components?: IApplicationMenuItemComponentModel[];
  activeComponent?: IApplicationMenuItemComponentModel;
  toggled?: boolean;
  onClick?: () => void;
}

const ApplicationMenuDropdown = ({
  className,
  components,
  activeComponent,
  toggled,
  onClick,
}: ApplicationMenuDropdownProps) => {
  const { t } = useTranslation("translations");

  return (
    <>
      {activeComponent && !toggled && (
        <button className={cx(styles.dropdown, className)} onClick={onClick}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            alt=""
            className={styles.icon}
            src={activeComponent.Icons?.compact}
          />

          {activeComponent.Title}

          <ChevronDown className={styles.chevron} />
        </button>
      )}

      {toggled && (
        <div className={cx(styles.container, className)}>
          <p className={styles.title}>{t("web_channel_selector_header")}</p>

          <div className={styles.channels}>
            {components?.map((component) => {
              const screenKey = ConfigurationHelper.getScreenRouteKey(
                component?.Action?.ScreenId,
                component?.Action?.ScreenTypeCode
              );

              return (
                <LinkWithLocale key={component.Id} href={screenKey}>
                  <a
                    className={cx(styles.channel, {
                      [styles.active]: component.Id === activeComponent?.Id,
                    })}
                    onClick={onClick}
                  >
                    <img alt="" src={component.Icons?.labeled} />
                  </a>
                </LinkWithLocale>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default ApplicationMenuDropdown;
